import React from 'react'
import { Link, graphql, useStaticQuery } from 'gatsby'
// eslint-disable-next-line import/extensions -- relative path; webpack has no `utils` alias
import { normalizeWpUrlForGatsby } from '../../utils/normalizeWpUrlForGatsby'

const isPartiallyActive = (data: any) => {
  let { isPartiallyCurrent } = data

  // if 'to' location is '/' and current page is home than set partially current
  if (data.location.pathname === '/' && data.href === '/home/') {
    isPartiallyCurrent = true
  }

  const hashSplit = data.href.split('#')

  // if 'to' has hash than custom check partially current
  if (hashSplit[1]) {
    hashSplit[0] = hashSplit[0].replace('/#', '')
    hashSplit[0] = hashSplit[0].replace('#', '')

    if (hashSplit[0] === data.location.pathname) {
      isPartiallyCurrent = true
    }
  }

  if (data.location.pathname !== '/' && data.href === '/') {
    isPartiallyCurrent = false
  }

  return isPartiallyCurrent ? { 'aria-current': `page` } : {}
}

interface CustomLinkProps {
  to: string
  className?: string
  target?: string
  rel?: string
  children: any
}

function CustomLink({
  to,
  className = '',
  rel = '',
  children,
  target,
}: CustomLinkProps) {
  const { site } = useStaticQuery<GatsbyTypes.CustomLinkSiteMetadataQuery>(
    graphql`
      query CustomLinkSiteMetadata {
        site {
          siteMetadata {
            siteUrl
            siteWpUrl
          }
        }
      }
    `
  )

  const normalizedTo = normalizeWpUrlForGatsby(to, {
    siteUrl: site?.siteMetadata?.siteUrl ?? '',
    siteWpUrl: site?.siteMetadata?.siteWpUrl ?? '',
  })

  return (
    <Link
      getProps={isPartiallyActive}
      to={normalizedTo}
      className={className}
      target={target}
      rel={rel}
    >
      {children}
    </Link>
  )
}

export default CustomLink
